import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SiteService } from 'src/app/core/services';

@Component({
  selector: 'app-inline-editor-dialog',
  templateUrl: './inline-edit-dialog.component.html',
  styleUrls: ['./inline-edit-dialog.component.scss']
})
export class InlineEditDialogComponent {
  form: FormGroup;
  statusMessage = '';
  loading = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<InlineEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { key: string; currentText: string; targetElement: HTMLElement },
    private siteService: SiteService
  ) {
    this.form = this.fb.group({
      newText: [data.currentText, [Validators.required, Validators.maxLength(1000)]]
    });
  }

  async onSave(): Promise<void> {
    if (this.form.invalid) return;

    const newText = this.form.value.newText;
    this.loading = true;
    this.statusMessage = '';

    try {
      await this.siteService.updateContent(this.data.key, newText);
      // Update inline text in DOM
      this.data.targetElement.innerText = newText;
      this.statusMessage = 'Content updated successfully!';
      setTimeout(() => this.dialogRef.close(), 800);
    } catch (err) {
      console.error(err);
      this.statusMessage = 'Failed to update content.';
    } finally {
      this.loading = false;
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
